export const ADD_CERTIFICATION = "ADD_CERTIFICATION";

export function addCertificationHandler(data) {
  return {
    type: ADD_CERTIFICATION,
    data,
  };
}
